module.exports = __webpack_public_path__ + "static/media/ReportMaximo.272760c3.svg";